/** Chỉ cho phép ký tự an toàn — tránh ký tự đặc biệt dễ gây lỗi / injection. */
const SAFE_PASSWORD_REGEX = /^[a-zA-Z0-9!@#$%^&*()_+=.,?]{6,128}$/;

export const PASSWORD_VALIDATION_HINT =
  'Mật khẩu 6–128 ký tự, chỉ dùng chữ, số và !@#$%^&*()_+=.,? (không dùng dấu -, dấu nháy, khoảng trắng, v.v.)';

export function validatePassword(password: string): string | null {
  if (!password || password.length < 6) {
    return 'Mật khẩu phải có ít nhất 6 ký tự';
  }
  if (password.length > 128) {
    return 'Mật khẩu không được quá 128 ký tự';
  }
  if (!SAFE_PASSWORD_REGEX.test(password)) {
    return PASSWORD_VALIDATION_HINT;
  }
  return null;
}
